import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SCHEDULE_SETTINGS_MEDIA_CONDITION } from '../../hooks/settings/use-schedule-settings-small-mode';

export const primaryButtonStyles = css({
  width: 'fit-content',
  margin: theme.spacing(0, 2, 4, 0),
  float: 'right',
  [SCHEDULE_SETTINGS_MEDIA_CONDITION]: {
    margin: theme.spacing(2, 0, 0),
    float: 'none',
  },
});
